import { CarrierStatusCode } from "../models/Carrier";

export const PROFILES = {
	supervisor: "Supervisor Profile",
	subAdmin: "SubAdmin Profile",
	admin: "admin Profile",
} as const;

export const PROFILE_HIERARCHY = [
	PROFILES.supervisor,
	PROFILES.subAdmin,
	PROFILES.admin,
] as const;

export type CarrierProfile = (typeof PROFILE_HIERARCHY)[number];

export type CarrierActionKey =
	| "signOff"
	| "newBuild"
	| "install"
	| "passChange"
	| "uninstall"
	| "edit"
	| "restart"
	| "disassemble";

export const CARRIER_POLICY: Record<
	CarrierStatusCode,
	Partial<Record<CarrierActionKey, CarrierProfile | null>>
> = {
	[CarrierStatusCode.Empty]: {
		newBuild: null,
	},
	[CarrierStatusCode.AssemblyInProgress]: {
		edit: null,
		restart: null,
	},
	[CarrierStatusCode.Complete]: {
		signOff: null,
		edit: PROFILES.supervisor,
		restart: null,
	},
	[CarrierStatusCode.SignedOff]: {
		install: null,
		edit: PROFILES.supervisor,
		restart: null,
	},
	[CarrierStatusCode.Installed]: {
		passChange: null,
		uninstall: null,
	},
	[CarrierStatusCode.Uninstalled]: {
		disassemble: null,
	},
	[CarrierStatusCode.Finished]: {
		restart: null,
	},
	[CarrierStatusCode.Inhibited]: {
		restart: null,
	},
};
